document.addEventListener('DOMContentLoaded', function () {
    // ========================================
    // サイト固有の設定（ここを編集）
    // ========================================
    const CONFIG = {
        // ヘッダー要素のセレクタ
        // 機能を使用しない場合は、空文字を定義する
        HEADER_SELECTOR_DESKTOP: '.hdr .hdr-nav', // PC
        HEADER_SELECTOR_MOBILE: '.hdr .hdr-logo', // タブレット以下

        // 追加するスペーサーのクラス名
        SPACER_CLASS: 'hdr-nav__space',

        // スクロール時に追加されるクラス名
        SCROLL_CLASS: 'scroll',

        // ブレークポイント
        MOBILE_BREAKPOINT: 840,

        // スクロール停止判定の data 属性名
        SCROLL_STOP_ATTRIBUTE: 'scrollstop'
    };

    // ========================================
    // 初期化
    // ========================================

    // 指定のページでページスクロールするかどうかの判定
    const scrollStop = document.body.dataset[CONFIG.SCROLL_STOP_ATTRIBUTE];
    if (scrollStop) return;

    let headerMenu = null;
    let headerMenuHeight = 0;
    let headerMenuPosition = 0;

    // ========================================
    // 関数定義
    // ========================================

    /**
     * ヘッダーメニューの位置を調整
     */
    function adjustMenu() {
        if (!headerMenu) return;

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const spacer = document.querySelector(`.${CONFIG.SPACER_CLASS}`);

        if (scrollTop > headerMenuPosition) {
            headerMenu.classList.add(CONFIG.SCROLL_CLASS);

            // スペーサーが存在しない場合のみ追加
            if (!spacer) {
                const newSpacer = document.createElement('div');
                newSpacer.className = CONFIG.SPACER_CLASS;
                newSpacer.style.height = `${headerMenuHeight}px`;
                headerMenu.parentNode.insertBefore(newSpacer, headerMenu);
            }
        } else {
            headerMenu.classList.remove(CONFIG.SCROLL_CLASS);

            // スペーサーが存在する場合は削除
            if (spacer) spacer.remove();
        }
    }

    /**
     * ヘッダーメニューの要素と位置を初期化
     */
    function initializeHeaderMenu() {
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;

        // 画面幅に応じてヘッダー要素を選択
        const selector = windowWidth > CONFIG.MOBILE_BREAKPOINT
            ? CONFIG.HEADER_SELECTOR_DESKTOP
            : CONFIG.HEADER_SELECTOR_MOBILE;

        headerMenu = selector ? document.querySelector(selector) : null;

        // 追従する要素が存在する場合
        if (headerMenu) {
            // 一旦固定を解除（元の高さを取得するため）
            headerMenu.classList.remove(CONFIG.SCROLL_CLASS);

            // ヘッダーの高さと位置を取得
            headerMenuHeight = headerMenu.offsetHeight;
            const rect = headerMenu.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            headerMenuPosition = rect.top + scrollTop;

            // メニュー位置の再調整
            adjustMenu();
        } else {
            // 追従する要素がない場合、スペーサーを削除
            // （ウィンドウリサイズ時の挙動を正常化するため）
            const spacer = document.querySelector(`.${CONFIG.SPACER_CLASS}`);
            if (spacer) spacer.remove();
        }
    }

    // ========================================
    // イベントバインド
    // ========================================

    // 初回実行
    initializeHeaderMenu();

    // ウィンドウのリサイズ時にヘッダーを初期化
    let resizeTimer;
    window.addEventListener('resize', function () {
        // リサイズイベントのデバウンス処理
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initializeHeaderMenu, 100);
    });

    // スクロール時にメニュー位置を調整
    window.addEventListener('scroll', adjustMenu);
});